











































































































































































import { Component, Vue } from 'vue-property-decorator'
import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage, maskDate, validateCPF, validateEmail } from '@/utils/common'
import { PessoaRemuneracao, AcessoRemuneracao, EnvioAutenticacaoPayload } from '@/types/interfaces/LiberacaoAcessoRemuneracao'

const PERFIL_REMUNERACAO = 'ExtratoPagamento'
const TAMANHO_CPF = 11

@Component
export default class ViewSuporteLiberarAcesso extends Vue {
  cpf = ''
  email = ''

  pessoa: PessoaRemuneracao | null = null
  acesso: AcessoRemuneracao | null = null
  hasSearched = false

  grupoHospitalId = ''
  nomeClienteAtivo = ''
  loadingContextoCliente = true

  loadingBuscarPessoa = false
  loadingLiberarAcesso = false

  get perfil() {
    return PERFIL_REMUNERACAO
  }

  get cpfSomenteDigitos() {
    return this.cpf.replace(/\D/g, '')
  }

  get isCpfInvalido() {
    return !validateCPF(this.cpfSomenteDigitos)
  }

  get mensagemErroCpf() {
    if (this.cpfSomenteDigitos.length === TAMANHO_CPF && this.isCpfInvalido) {
      return 'CPF inválido. Confira os números.'
    }

    return ''
  }

  get hasPessoa() {
    return !!this.pessoa
  }

  get isPessoaNaoEncontrada() {
    return this.hasSearched && !this.pessoa
  }

  get hasAcesso() {
    return !!this.acesso
  }

  get isAcessoAtivo() {
    return !!this.acesso && this.acesso.ativo
  }

  get isAcessoDesativado() {
    return !!this.acesso && !this.acesso.ativo
  }

  // Ter cadastro não é ter acesso. Oferecer a liberação a quem já tem regrava o usuário no
  // FinxSeguranca e pode trocar o login do médico pelo e-mail que o suporte digitar.
  get canShowFormLiberacao() {
    return this.hasPessoa && !this.hasAcesso
  }

  // São e-mails diferentes: o do cadastro é de notificação, o do acesso é o login. Mostrar os
  // dois ao mesmo tempo confunde, e o do cadastro só serve quando ainda há liberação a fazer.
  get canShowEmailCadastrado() {
    return !this.hasAcesso
  }

  get perfilAcesso() {
    return (this.acesso && this.acesso.perfil) || '-'
  }

  get emailAcesso() {
    return (this.acesso && this.acesso.emailUsuario) || 'Não informado'
  }

  get dataLiberacaoAcesso() {
    if (!this.acesso || !this.acesso.dataLiberacao) {
      return '-'
    }

    return maskDate(this.acesso.dataLiberacao)
  }

  get nomePessoaEncontrada() {
    return (this.pessoa && this.pessoa.nome) || ''
  }

  get emailPessoaEncontrada() {
    return (this.pessoa && this.pessoa.emailNotificacao) || 'Não informado'
  }

  get isFormLiberacaoInvalido() {
    return !validateEmail(this.email)
  }

  get hasClienteAtivo() {
    return !!this.grupoHospitalId
  }

  get isClienteIndefinido() {
    return !this.loadingContextoCliente && !this.grupoHospitalId
  }

  get canBuscarPessoa() {
    return !this.isCpfInvalido && !this.loadingBuscarPessoa && this.hasClienteAtivo
  }

  get canLiberarAcesso() {
    return !this.isFormLiberacaoInvalido && !this.loadingLiberarAcesso && this.hasClienteAtivo
  }

  async loadContextoCliente() {
    this.loadingContextoCliente = true

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGrupoHospital()

    if (!response.success || !response.data) {
      this.loadingContextoCliente = false
      return
    }

    this.grupoHospitalId = response.data.id
    await this.loadNomeClienteAtivo()

    this.loadingContextoCliente = false
  }

  async loadNomeClienteAtivo() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllGrupoHospital()

    if (!response.success || !response.data || !response.data.itens) {
      this.nomeClienteAtivo = this.grupoHospitalId
      return
    }

    const grupo = response.data.itens.find(item => item.id === this.grupoHospitalId)

    this.nomeClienteAtivo = grupo ? grupo.nome : this.grupoHospitalId
  }

  resetResultadoBusca() {
    this.pessoa = null
    this.acesso = null
    this.hasSearched = false
    this.email = ''
  }

  // A consulta é na base de remuneração, e não no Cadastro, porque é dela que a liberação
  // lê o documento: quem não está aqui é recusado com "Documento inválido".
  async loadPessoaByCpf() {
    this.resetResultadoBusca()
    this.loadingBuscarPessoa = true

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPessoaPorDocumento(this.cpfSomenteDigitos)

    this.loadingBuscarPessoa = false

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Não foi possível consultar o CPF. Tente novamente.', 'error'))
      return
    }

    this.hasSearched = true
    this.pessoa = (response.data && response.data.pessoa) || null
    this.acesso = (response.data && response.data.acesso) || null
    this.email = this.pessoa && this.pessoa.emailNotificacao ? this.pessoa.emailNotificacao : ''
  }

  async createAcessoRemuneracao() {
    if (!this.pessoa) {
      return
    }

    this.loadingLiberarAcesso = true

    const payload: EnvioAutenticacaoPayload = {
      id: this.pessoa.userId,
      name: this.nomePessoaEncontrada,
      email: this.email,
      perfil: PERFIL_REMUNERACAO,
    }

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.criarUsuario(payload)

    this.loadingLiberarAcesso = false

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao liberar o acesso.', 'error'))
      return
    }

    EventBus.$emit('setSnackbar', getSnackbarMessage('Acesso liberado com sucesso!', 'success'))
    this.$router.push('/suporte/usuarios')
  }

  async created() {
    await this.loadContextoCliente()

    const { cpf } = this.$route.params

    if (!cpf) {
      return
    }

    this.cpf = cpf

    if (this.isCpfInvalido) {
      return
    }

    this.loadPessoaByCpf()
  }
}
